import React from 'react'
import './Dashboard.css'
import { ButtonPrimary, ButtonSecoundry, PageHead, SectionWrap } from '../../Components'
import { useTranslation } from 'react-i18next';
import { BsDisplay } from 'react-icons/bs';


function Dashboard() {
  const { t, i18n } = useTranslation();

  return (
    <>
    <PageHead title="لوحة التحكم" />
    <div className=' containerNew'>
    <SectionWrap>
        <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center'}}>
            <ButtonSecoundry href='/subsList'>إدارة الاشتراكات</ButtonSecoundry>
            <ButtonSecoundry href='/appointmentManag'>مواعيد الاستشارات</ButtonSecoundry>
            <ButtonSecoundry href='/CaseDash'>قضايا الموكلين</ButtonSecoundry>
        </div>
    </SectionWrap>
    </div>
    </>
  )
}

export default Dashboard;
